import { Checkbox, Dropdown, Image, Input } from "antd";
import { DashOutlined } from "@ant-design/icons";
import moment from "moment";
import { useDrag, useDrop } from "react-dnd";

import ImageIcon from "images/imageIcon.png";
import VideoIcon from "images/videoIcon.png";

import axios from "axios";
import { useEffect, useState } from "react";
import { ytPattern } from "components/Embed";

import "./AssetView.scss";

const AssetFile = ({
  file,
  index,
  handleDrag,
  handleDrop,
  onView,
  onDelete,
  selected,
  onToggleSelect,
}) => {
  const [isActive, setIsActive] = useState(file.active || true);
  const [fetchedTitle, setFetchedTitle] = useState(null);

  const [, ref] = useDrag({
    type: file.tabId,
    item: { index, ...file },
  });

  const fileSize = file.size || (file?.fileSize / 1024).toFixed(2);

  const getDisplayName = () => {
    const title = file.title || fetchedTitle;
    if (title) {
      const sourceLabel = file.source ? file.source.charAt(0).toUpperCase() + file.source.slice(1) : "";
      if (sourceLabel && !title.toLowerCase().includes(sourceLabel.toLowerCase())) {
        return `${sourceLabel} - ${title}`;
      }
      return title;
    }
    if (file.source === "youtube" || file.fileUrl?.includes("youtube") || file.fileUrl?.includes("youtu.be")) {
      return `Youtube - ${file.fileUrl}`;
    }
    if (file.source === "vimeo" || file.fileUrl?.includes("vimeo")) {
      return `Vimeo - ${file.fileUrl}`;
    }
    if (file.source === "twitter" || file.fileUrl?.includes("twitter") || file.fileUrl?.includes("x.com")) {
      return `Twitter - ${file.fileUrl}`;
    }
    if (file.source === "linkedin" || file.fileUrl?.includes("linkedin")) {
      return `LinkedIn - ${file.fileUrl}`;
    }
    if (file.source === "instagram" || file.fileUrl?.includes("instagram")) {
      return `Instagram - ${file.fileUrl}`;
    }
    if (file.source === "tiktok" || file.fileUrl?.includes("tiktok")) {
      return `TikTok - ${file.fileUrl}`;
    }
    if (file.source) {
      return `${file.source.charAt(0).toUpperCase() + file.source.slice(1)} - ${file.fileName || file.fileUrl}`;
    }
    return file.fileName || file.fileUrl;
  };

  useEffect(() => {
    if (ytPattern.test(file.fileUrl)) {
      checkAvailable();
    }
    if (!file.title && (
      file.source === "youtube" || file.source === "vimeo" ||
      file.fileUrl?.includes("youtube") || file.fileUrl?.includes("youtu.be") || file.fileUrl?.includes("vimeo")
    )) {
      fetchTitle();
    }
  }, [file]);

  const fetchTitle = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/moodboards/fetch-title`,
        { fileUrl: file.fileUrl, source: file.source }
      );
      if (res.data?.title) {
        setFetchedTitle(res.data.title);
      }
    } catch (e) {}
  };

  const checkAvailable = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/video/check-link-status`,
        { videoUrl: file.fileUrl }
      );
      setIsActive(res.data.isValid);
    } catch (e) {
      console.log("check available error", e);
    }
  };

  const [, drop] = useDrop({
    accept: file.tabId,
    hover: (draggedItem) => {
      if (draggedItem.index !== index) {
        handleDrag(draggedItem.index, index, file);
        draggedItem.index = index;
      }
    },
    drop: (item) => {
      handleDrop(item);
    },
  });

  return (
    <div
      ref={(node) => ref(drop(node))}
      className={`table-column ${selected ? "asset-selected" : ""}`}
      onDoubleClick={() => onView(file._id)}
    >
      <div className="asset-checkbox">
        <Checkbox checked={selected} onChange={onToggleSelect} />
      </div>
      <div className={`asset-row ${!isActive && "asset-inactive"}`}>
        <Image
          src={file.type === "image" ? ImageIcon : VideoIcon}
          className="file-type-icon"
          preview={false}
        />
        {getDisplayName()}
      </div>
      <div className="break-word">{fileSize > 0 ? `${fileSize} MB` : ""}</div>

      <div className="break-word">
        {moment(file.date).format("DD MMM YYYY")}
      </div>

      <div className="break-word capitalize">{file.source}</div>
      <Dropdown
        menu={{
          items: [
            {
              label: <div onClick={() => onView(file._id)}>View comments</div>,
              key: "1",
            },
            {
              label: <div onClick={() => onDelete(file._id)}>Delete</div>,
              key: "3",
            },
          ],
        }}
        trigger={["click"]}
      >
        <DashOutlined className="more-asset-icon" />
      </Dropdown>
    </div>
  );
};

export default AssetFile;
